<template>
  <v-flex xs12>
    <v-tabs-items v-model="selectedVisualization">
      <v-tab-item key="activate-map" :value="`activate-map`">
        <map-chart
          ref="mapRef"
          :chart-data="dto"
          :width="visWidth"
          :height="visHeight"
          @click:item="clickItem($event)"
        ></map-chart>
      </v-tab-item>
      <v-tab-item key="activate-barchart" :value="`activate-barchart`">
        <bar-chart
          :chart-data="dataForBarChart"
          :width="visWidth"
          :height="visHeight"
          :selectedSorting="selectedSorting"
          @input:selectedSorting="selectSorting($event)"
          @click:item="clickItem($event)"
        >
        </bar-chart>
      </v-tab-item>
      <v-tab-item
        key="activate-linechart"
        :value="`activate-linechart`"
        :disabled="true"
      >
      </v-tab-item>
      <v-tab-item key="activate-table" :value="`activate-table`">
        <table-chart
          :chart-data="dto"
          :width="visWidth"
          :height="visHeight"
          @click:item="clickItem($event)"
        ></table-chart>
      </v-tab-item>
    </v-tabs-items>
    <!-- fact sheet drawer !-->
    <fact-sheet
      v-model="factSheet"
      :height="visHeight"
      :vis-width="visWidth"
    >
    </fact-sheet>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex'
import MapChart from './Map'

const FactSheet = () => import('@/components/FactSheet')
const BarChart = () => import('@/components/BarChart')
const TableChart = () => import('@/components/Table')

export default {
  props: ['visualizationType', 'factSheet', 'visWidth', 'visHeight'],
  data: () => ({
    selectedSorting: 'A-Z'
  }),
  components: {
    MapChart,
    BarChart,
    TableChart,
    FactSheet
  },
  computed: {
    ...mapState(['selectedYear', 'selectedYearSpan', 'selectedVisualization']),
    dto () {
      let result = Object.assign({}, this.$store.getters.getDTO)
      result.data = result.data.filter(d => d.year === this.selectedYear.year)
      return result
    },
    dataForBarChart () {
      let result = Object.assign({}, this.$store.getters.getDTO)
      // exclude null values from bar chart
      result.data = result.data.filter(d => d.year === this.selectedYear.year && d.value != null)
      return result
    }
  },
  methods: {
    selectSorting (item) {
      this.selectedSorting = item
    },
    clickItem (item) {
      this.$emit('click:item', item)
    },
    tabClicked () {
      let that = this
      setTimeout(function () { that.$refs.mapRef.resize() }, 0)
    }
  },
  watch: {
    selectedVisualization (val) {
      if (val === 'activate-map') {
        this.tabClicked()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts.vue